export default __webpack_public_path__ + "static/media/JobTerix-full.6f3d78c1.svg";